import { api } from './client';

/** Web Push (VAPID) — см. backend PushController. 404 на ключ = на сервере push не настроен. */
export function getVapidPublicKey(): Promise<{ publicKey: string }> {
  return api('/api/v1/push/vapid-public-key');
}

export function savePushSubscription(sub: PushSubscriptionJSON) {
  return api('/api/v1/push/subscriptions', { method: 'POST', body: JSON.stringify(sub) });
}

export function deletePushSubscription(endpoint: string) {
  return api(`/api/v1/push/subscriptions?endpoint=${encodeURIComponent(endpoint)}`, { method: 'DELETE' });
}
